import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-accept-terms',
  templateUrl: './accept-terms.component.html',
  styleUrls: ['./accept-terms.component.scss']
})
export class AcceptTermsComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  closeModal () {
    this.activeModal.dismiss();
  }

}



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/auth/accept-terms/accept-terms.component.ts